







import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { setCredentials } from "../../../Redux/Slices/AuthSlice"; // adjust path if needed
import { BASE_URL } from "../../../components/BaseUrl";
import profilecross from "../../../assets/profilecross.svg";
import profileperson from "../../../assets/profileperson.png";
import CustomText, { textStyles } from "../../../components/CustomText";
import active from "../../../assets/Dashboard/active.svg";
import activearrow from "../../../assets/activearrow.svg";
import down from "../../../assets/down.svg";
import code from "../../../assets/code.svg";
import toggle from "../../../assets/toggle.svg";
import toggleoff from "../../../assets/Settings/toggleoff.svg";
import trial from "../../../assets/Dashboard/trial.svg";
import company from "../../../assets/company.png";
import invited from '../../../assets/Dashboard/invited.svg';
import CustomButton from "../../../components/CustomButton";
import inactive from '../../../assets/Dashboard/inactive.svg';
import request from '../../../assets/Dashboard/request.svg';
import process from "../../../assets/Dashboard/process.svg";
import overdue from "../../../assets/Dashboard/overdue.svg";
import received from "../../../assets/Wallet/received.svg";
import pending from "../../../assets/Wallet/pending.svg";
import { Drawer, Box, Typography, IconButton, Divider, Chip, Switch, } from "@mui/material";
import { decryptToken } from "../../../Utlis/Encryption";
import StatusDropdown from '../../../components/StatusDropdown';
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import dummy from "../../../assets/dummy.png";
import { useTheme } from "../../../contexts/ThemeContext";
import { getApiMessage } from '../../../utils/messageHandler';

const ProfileDrawer = ({ open, onClose }) => {
  const statusIcons = {
    Active: active,
    Trial: trial,
    Invited: invited,
    Inactive: inactive,
    Requested: request,
    Overdue: overdue,
    Processing: process,
    Paid: active,
    Pending: pending,
    Received: received
  };
  const statusStyles = {
    Active: { backgroundColor: '#4BCE97', color: '#164B35' },
    Trial: { backgroundColor: '#FEA362', color: '#702E00' },
    Invited: { backgroundColor: '#579DFF', color: '#09326C' },
    Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
    Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
    Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
    Overdue: { backgroundColor: '#FFA26B', color: '#722800' },
    Pending: { backgroundColor: '#F5CD47', color: '#533F04', },
    Received: { backgroundColor: '#4BCE97', color: '#164B35', }
  };
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const { t } = useTranslation();
  const { companyLogo } = useTheme();
  useEffect(() => {

    if (open && token) {

      fetchProfileData();
    } else if (open && !token) {

      toast.error("You are not logged in. Please log in.");
      navigate("/"); // Go to home or login
    }
  }, [open, token]);



  const fetchProfileData = async () => {
    try {
      const response = await fetch(`${BASE_URL}/workers/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      // 👇 this will always log the full API response clearly
      console.log("==== 🔎 FULL PROFILE API RESPONSE ====");
      console.log("Status:", response.status);
      console.log("OK?:", response.ok);
      console.log("Data:", JSON.stringify(data, null, 2));
      console.log("======================================");

      if (!response.ok || data.message === "Invalid token. Please log in again.") {
        toast.error(getApiMessage(data, "Session expired. Please log in again."));
        navigate("/");
        return;
      } setProfile(data.data.profile);

      // set dropdown status from API
      if (data.data.profile.status) {
        setVerificationStatus(
          data.data.profile.status.charAt(0).toUpperCase() + data.data.profile.status.slice(1)
        );
      }

    } catch (err) {
      console.error("❌ Fetch profile error:", err);
      const errorMsg = err.response?.data ? getApiMessage(err.response.data, "Something went wrong while fetching profile.") : (err.message || "Something went wrong while fetching profile.");
      toast.error(errorMsg);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const onAvatarClick = () => {
    if (!uploading) fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploading(true);
      const form = new FormData();
      form.append("image", file);

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Upload failed");

      // Get uploaded image URL from server response
      const rawUrl = data?.data?.url || data?.url || data?.path;
      if (!rawUrl) throw new Error("No image URL returned");

      // Convert to full URL if needed
      const uploadedUrl = rawUrl.startsWith("http") ? rawUrl : `${BASE_URL}${rawUrl}`;

      // Fetch as blob
      const imgRes = await fetch(uploadedUrl, { headers: { Authorization: `Bearer ${token}` } });
      if (!imgRes.ok) throw new Error("Failed to fetch uploaded image");

      const blob = await imgRes.blob();
      const objectURL = URL.createObjectURL(blob);

      // Show blob instead of direct URL
      setProfile((prev) => ({
        ...prev,
        profile_picture: objectURL,
      }));

      toast.success("Profile picture updated.");
      e.target.value = "";
    } catch (err) {
      const errorMsg = err.response?.data ? getApiMessage(err.response.data, "Image upload failed.") : (err.message || "Image upload failed.");
      toast.error(errorMsg);
    } finally {
      setUploading(false);
    }
  };

  const getProfileImageSrc = (raw) => {
    if (!raw) return dummy;                  // fallback if no image
    if (raw.startsWith("data:")) return raw; // if backend ever returns base64
    if (/^https?:\/\//i.test(raw)) return raw; // full URL (your case)
    const prefix = raw.startsWith("/") ? "" : "/";
    return `${BASE_URL}${prefix}${raw}`;     // relative path → absolute
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 560, maxWidth: "100vw", height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Sticky Header */}
        <Box sx={{ position: "sticky", top: 0, zIndex: 10, backgroundColor: "#E7EBEE", p: 1.3, borderBottom: "1px solid #eee" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 1 }}>
            <IconButton onClick={onClose}>
              <img src={profilecross} alt="close" />
            </IconButton>
            <CustomText sx={{ ...textStyles.h1, fontSize: 22, fontWeight: 600, color: "#2C384C" }}>
              {t("profileDrawer.profileTitle")}
            </CustomText>
          </Box>
        </Box>
        <Box sx={{ overflowY: "auto", flexGrow: 1, p: 2 }}>
          <CustomText sx={{ ...textStyles.h1, fontSize: 18, mb: 3, mt: 1, fontWeight: 600, color: "#000000", textAlign: "left" }}>
            {t("profileDrawer.personalDetails")}
          </CustomText>

          <Box p={2} borderRadius={2} sx={{ pt: 2, mt: 2, backgroundColor: "#fff", border: "1px solid #091E4224", borderRadius: "10px" }}>

            <Box sx={{ textAlign: "center", position: "relative" }}>

              <img
                crossOrigin="anonymous"
                src={getProfileImageSrc(profile?.profile_image)}
                alt="avatar"
                style={{
                  width: 150,
                  height: 150,
                  objectFit: "cover",
                  borderRadius: "50%",
                  border: "1px solid #E5E7EB",
                }}
                onError={(e) => (e.currentTarget.src = dummy)}
              />
              {uploading && (
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                  }}
                >
                  <CustomText sx={{ ...textStyles.h1, fontSize: 12, color: "#2C384C" }}>
                    Uploading…
                  </CustomText>
                </Box>
              )}

              <input
                ref={fileInputRef}
                type="file"
                accept="image/png,image/jpeg,image/webp,image/gif"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </Box>



            <Box mt={2}>

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5, }}>

                <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
                  {t("profileDrawer.status")}
                </CustomText>
                {profile?.status && (
                  <Box>
                    <StatusDropdown
                      currentStatus={verificationStatus}
                      onChange={(newStatus) => {
                        console.log("🔁 Status changed to:", newStatus);
                        setVerificationStatus(newStatus);
                      }}
                    />
                  </Box>
                )}

              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                <InfoRow label={t("profileDrawer.registeredOn")} value={profile ? formatDate(profile.created_at) : "--"} />
                <InfoRow label={t("profileDrawer.fullName")}
                  // value={profile?.name || "--"}
                  //     value={
                  //   profile?.first_name && profile?.last_name 
                  //     ? `${profile.first_name}  ${profile.last_name}` 
                  //     : profile?.first_name  || profile?.last_name || "--"
                  // } 
                  value={
                    profile?.first_name && profile?.last_name
                      ? `${profile.first_name} ${profile.middle_name ? profile.middle_name + " " : ""}${profile.last_name}`
                      : profile?.first_name || profile?.middle_name || profile?.last_name || "--"
                  }
                />
                <InfoRow label={t("profileDrawer.phone")} value={profile?.phone || "--"} />
                <InfoRow label={t("profileDrawer.email")} value={profile?.email || "--"} />
              </Box>
            </Box>
          </Box>


          <SectionHeader label={t("profileDrawer.addressDetails")} icon={down} />
          <InfoBox sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <InfoRow label={t("profileDrawer.country")} value={profile?.country || "--"} />
            <InfoRow label={t("profileDrawer.province")} value={profile?.province || "--"} />
            <InfoRow label={t("profileDrawer.city")} value={profile?.city || "--"} />
            <InfoRow label={t("profileDrawer.postalCode")} value={profile?.postal_code || "--"} />
            <InfoRow label={t("profileDrawer.streetAddress")} value={profile?.street_address || "--"} />
            {/* <InfoRow label={t("profileDrawer.region")} value={profile?.assign_region || "--"} /> */}
          </InfoBox>
          <SectionHeader label={t("profileDrawer.workerDetails")} icon={down} />
          <InfoBox>
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <img
                src={companyLogo && companyLogo.trim() !== "" ? companyLogo : dummy}
                alt="Company Logo"
                crossOrigin="anonymous"
                onError={(e) => (e.currentTarget.src = dummy)}
                style={{
                  width: 150,
                  height: 150,
                  objectFit: "cover",
                  borderRadius: "50%",
                  border: "1px solid #E5E7EB",
                }}
              />
            </Box>

            <InfoRow label={t("profileDrawer.companyName")} value={profile?.company_name || "--"} />
            <InfoRow label={t("profileDrawer.companyEmail")} value={profile?.company_email || "--"} />
            <InfoRow label={t("profileDrawer.department")} value={profile?.department_name || "--"} />
            <InfoRow label={t("profileDrawer.workerId")} value={profile?.id || "--"} />
            <InfoRow label={t("profileDrawer.designation")} value={profile?.designation || "--"} />
            <InfoRow label={t("profileDrawer.employeeType")} value={profile?.employee_type || "--"} />
            <InfoRow label={t("profileDrawer.hireDate")} value={profile ? formatDate(profile.hire_date) : "--"} />
          </InfoBox>

        </Box>
      </Box>
    </Drawer>
  );
};

const InfoRow = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
    <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>{label}</CustomText>
    <CustomText sx={{ ...textStyles.h1, fontSize: 15, fontWeight: 400, color: "#172B4D", textAlign: "right" }}>{value}</CustomText>
  </Box>
);

const SectionHeader = ({ label, icon }) => (
  <Box mt={2.5} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000000", textAlign: "left" }}>{label}</CustomText>
  </Box>
);

const InfoBox = ({ children }) => (
  <Box mt={2} sx={{ border: "1px solid #091E4224", borderRadius: "10px", px: 2, py: 2 }}>
    {children}
  </Box>
);

const ChipList = ({ items }) => (
  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
    {items.length > 0 ? (
      items.map((item, i) => (
        <Box key={i} sx={{
          backgroundColor: "#579DFF",
          color: "#09326C",
          px: 1.5,
          py: 0.6,
          borderRadius: "4px",
          fontSize: "14px",
          fontWeight: 400,
          fontFamily: "Poppins, sans-serif"
        }}>
          {item}
        </Box>
      ))
    ) : (
      <CustomText sx={{ fontSize: 14, color: "#999" }}>--</CustomText>
    )}
  </Box>
);

export default ProfileDrawer;







